import Add from './Add';
import AddChat from './AddChat';
import AddCircle from './AddCircle';
import AddCircleOutline from './AddCircleOutline';
import AddComment from './AddComment';
import AddGroup from './AddGroup';
import AddPerson from './AddPerson';
import AddPhotos from './AddPhotos';
import AddShoutout from './AddShoutout';
import AdPlayazFilled from './AdPlayazFilled';
import AdPlayazOutline from './AdPlayazOutline';
import AllInclusive from './AllInclusive';
import ArrowLeft from './ArrowLeft';
import ArrowLeftLong from './ArrowLeftLong';
import ArrowLeftRounded from './ArrowLeftRounded';
import ArrowRight from './ArrowRight';
import ArrowRightLong from './ArrowRightLong';
import ArrowRightLonger from './ArrowRightLonger';
import ArrowRightRounded from './ArrowRightRounded';
import Athletes from './Athletes';
import Attach from './Attach';
import BarChart from './BarChart';
import Block from './Block';
import BrowseFilled from './BrowseFilled';
import BrowseOutline from './BrowseOutline';
import Calendar from './Calendar';
import Camera from './Camera';
import Cart from './Cart';
import ChangePassword from './ChangePassword';
import Chat from './Chat';
import Check from './Check';
import CheckIn from './CheckIn';
import Clean from './Clean';
import Clone from './Clone';
import Close from './Close';
import CloseCircled from './CloseCircled';
import CloseOutline from './CloseOutline';
import Contact from './Contact';
import DashboardFilled from './DashboardFilled';
import DashboardOutline from './DashboardOutline';
import Delete from './Delete';
import Done from './Done';
import DoneOutline from './DoneOutline';
import DoubleCheck from './DoubleCheck';
import Down from './Down';
import DownFilled from './DownFilled';
import DownThin from './DownThin';
import Edit from './Edit';
import Refresh from './Refresh';
import EmailNotification from './EmailNotification';
import Emoji from './Emoji';
import Event from './Event';
import Expand from './Expand';
import FactCheck from './FactCheck';
import Filter from './Filter';
import FlashOff from './FlashOff';
import FlashOn from './FlashOn';
import ForwardToInbox from './ForwardToInbox';
import Gallery from './Gallery';
import Game from './Game';
import Heart from './Heart';
import Hide from './Hide';
import HomeFilled from './HomeFilled';
import HomeOutline from './HomeOutline';
import Image from './Image';
import Language from './Language';
import LeftChevron from './LeftChevron';
import Like from './Like';
import Link from './Link';
import LiveTV from './LiveTV';
import Logout from './Logout';
import MarkEmailRead from './MarkEmailRead';
import MarketplaceFilled from './MarketplaceFilled';
import MarketplaceOutline from './MarketplaceOutline';
import Megaphone from './Megaphone';
import Menu from './Menu';
import MessagesFilled from './MessagesFilled';
import MessagesOutline from './MessagesOutline';
import Microphone from './Microphone';
import Minus from './Minus';
import MusicOff from './MusicOff';
import Mute from './Mute';
import NoPhotos from './NoPhotos';
import Notification from './Notification';
import NotificationFilled from './NotificationFilled';
import NotificationOutline from './NotificationOutline';
import Palette from './Palette';
import Pause from './Pause';
import People from './People';
import Play from './Play';
import PlayCircle from './PlayCircle';
import PlayCircleWebsite from './PlayCircleWebsite';
import PlayOutline from './PlayOutline';
import Plus from './Plus';
import Police from './Police';
import Privacy from './Privacy';
import PrivacyProfile from './PrivacyProfile';
import PrivacyProfileWithProfileIcon from './PrivacyProfileWithProfileIcon';
import ProfileBox from './ProfileBox';
import ProfileFilled from './ProfileFilled';
import ProfileOutline from './ProfileOutline';
import ProfileVerified from './ProfileVerified';
import Receipt from './Receipt';
import Repost from './Repost';
import RequestsFilled from './RequestsFilled';
import RequestsOutline from './RequestsOutline';
import Right from './Right';
import RightChevron from './RightChevron';
import RoundedHome from './RoundedHome';
import RoundedLike from './RoundedLike';
import RoundedQuestionMark from './RoundedQuestionMark';
import Ruler from './Ruler';
import Schedule from './Schedule';
import ScheduleAvailable from './ScheduleAvailable';
import ScheduleCancelled from './ScheduleCancelled';
import ScheduleNote from './ScheduleNote';
import SchedulePending from './SchedulePending';
import Search from './Search';
import Send from './Send';
import SendOutline from './SendOutline';
import Settings from './Settings';
import Share from './Share';
import ShoutoutFilled from './ShoutoutFilled';
import ShoutoutMegaphoneOutline from './ShoutoutMegaphoneOutline';
import ShoutoutOutline from './ShoutoutOutline';
import SortVariant from './SortVariant';
import Sport from './Sport';
import SquareProfile from './SquareProfile';
import StarFilled from './StarFilled';
import StarOutline from './StarOutline';
import StoreFilled from './StoreFilled';
import StoreOutline from './StoreOutline';
import Suggested from './Suggested';
import SwitchCamera from './SwitchCamera';
import SwitchCamera2 from './SwitchCamera2';
import Throphy from './Throphy';
import Trashbin from './Trashbin';
import Unlike from './Unlike';
import Up from './Up';
import Upload from './Upload';
import Verified from './Verified';
import Video from './Video';
import VideoCamera from './VideoCamera';
import VideoOff from './VideoOff';
import VisibleOff from './VisibleOff';
import VisibleOn from './VisibleOn';
import Warning from './Warning';
import WarningOutline from './WarningOutline';
import Stripe from './Stripe';
import Komoju from './Komoju';
import CreditCard from './CreditCard';
import ApplePay from './ApplePay';
import GooglePay from './GooglePay';
import Lock from './Lock';
import SubscribedCheck from './SubscribedCheck';
import PaywallMessageCircle from './PaywallMessageCircle';
import PaywallWand from './PaywallWand';
import PaywallShield from './PaywallShield';
import PaywallCrown from './PaywallCrown';
import PaywallCheck from './PaywallCheck';
import PaywallApple from './PaywallApple';
import PaywallCircleX from './PaywallCircleX';
import PaywallCreditCard from './PaywallCreditCard';

// nations
import Abkhazia from './nations/Abkhazia';
import Afghanistan from './nations/Afghanistan';
import AlandIslands from './nations/AlandIslands';
import Albania from './nations/Albania';
import Algeria from './nations/Algeria';
import AmericanSamoa from './nations/AmericanSamoa';
import Andorra from './nations/Andorra';
import Angola from './nations/Angola';
import Anguilla from './nations/Anguilla';
import AntiguaAndBarbuda from './nations/AntiguaAndBarbuda';
import Argentina from './nations/Argentina';
import Armenia from './nations/Armenia';
import Aruba from './nations/Aruba';
import Australia from './nations/Australia';
import Austria from './nations/Austria';
import Azerbaijan from './nations/Azerbaijan';
import AzoresIslands from './nations/AzoresIslands';
import Bahamas from './nations/Bahamas';
import Bahrain from './nations/Bahrain';
import BalearicIslands from './nations/BalearicIslands';
import Bangladesh from './nations/Bangladesh';
import Barbados from './nations/Barbados';
import BasqueCountry from './nations/BasqueCountry';
import Belarus from './nations/Belarus';
import Belgium from './nations/Belgium';
import Belize from './nations/Belize';
import Benin from './nations/Benin';
import Bermuda from './nations/Bermuda';
import Bhutan from './nations/Bhutan';
import Bonaire from './nations/Bonaire';
import BritishIndianOceanTerritory from './nations/BritishIndianOceanTerritory';
import BritishVirginIslands from './nations/BritishVirginIslands';
import Brunei from './nations/Brunei';
import Bulgaria from './nations/Bulgaria';
import BurkinaFaso from './nations/BurkinaFaso';
import Burundi from './nations/Burundi';
import Cambodia from './nations/Cambodia';
import Cameroon from './nations/Cameroon';
import Canada from './nations/Canada';
import CanaryIslands from './nations/CanaryIslands';
import CapeVerde from './nations/CapeVerde';
import CaymanIslands from './nations/CaymanIslands';
import CentralAfricanRepublic from './nations/CentralAfricanRepublic';
import Ceuta from './nations/Ceuta';
import Chad from './nations/Chad';
import Chile from './nations/Chile';
import China from './nations/China';
import CocosIslands from './nations/CocosIslands';
import Colombia from './nations/Colombia';
import Comoros from './nations/Comoros';
import Congo from './nations/Congo';
import CookIslands from './nations/CookIslands';
import Corsica from './nations/Corsica';
import CostaRica from './nations/CostaRica';
import Croatia from './nations/Croatia';
import Cuba from './nations/Cuba';
import Curacao from './nations/Curacao';
import Cyprus from './nations/Cyprus';
import CzechRepublic from './nations/CzechRepublic';
import Denmark from './nations/Denmark';
import Djibouti from './nations/Djibouti';
import Dominica from './nations/Dominica';
import DominicanRepublic from './nations/DominicanRepublic';
import EastTimor from './nations/EastTimor';
import Ecuador from './nations/Ecuador';
import Egypt from './nations/Egypt';
import ElSalvador from './nations/ElSalvador';
import England from './nations/England';
import EquatorialGuinea from './nations/EquatorialGuinea';
import Eritrea from './nations/Eritrea';
import Estonia from './nations/Estonia';
import Ethiopia from './nations/Ethiopia';
import EuropeanUnion from './nations/EuropeanUnion';
import FalklandIslands from './nations/FalklandIslands';
import FaroeIslands from './nations/FaroeIslands';
import Fiji from './nations/Fiji';
import Finland from './nations/Finland';
import France from './nations/France';
import FrenchPolynesia from './nations/FrenchPolynesia';
import Gabon from './nations/Gabon';
import GalapagosIslands from './nations/GalapagosIslands';
import Gambia from './nations/Gambia';
import Georgia from './nations/Georgia';
import Germany from './nations/Germany';
import Ghana from './nations/Ghana';
import Gibraitar from './nations/Gibraitar';
import Greece from './nations/Greece';
import Greenland from './nations/Greenland';
import Grenada from './nations/Grenada';
import Guam from './nations/Guam';
import Guatemala from './nations/Guatemala';
import Guernsey from './nations/Guernsey';
import Guinea from './nations/Guinea';
import GuineaBissau from './nations/GuineaBissau';
import Guyana from './nations/Guyana';
import Haiti from './nations/Haiti';
import Hawaii from './nations/Hawaii';
import Honduras from './nations/Honduras';
import HongKong from './nations/HongKong';
import Hungary from './nations/Hungary';
import Iceland from './nations/Iceland';
import India from './nations/India';
import Indonesia from './nations/Indonesia';
import Iran from './nations/Iran';
import Iraq from './nations/Iraq';
import Ireland from './nations/Ireland';
import IsleOfMan from './nations/IsleOfMan';
import Israel from './nations/Israel';
import Italy from './nations/Italy';
import IvoryCoast from './nations/IvoryCoast';
import Jamacia from './nations/Jamacia';
import Japan from './nations/Japan';
import Jersey from './nations/Jersey';
import Jordan from './nations/Jordan';
import Kazakhstan from './nations/Kazakhstan';
import Kenya from './nations/Kenya';
import Kiribati from './nations/Kiribati';
import Kosovo from './nations/Kosovo';
import Kuwait from './nations/Kuwait';
import Kyrgyzstan from './nations/Kyrgyzstan';
import Laos from './nations/Laos';
import Latvia from './nations/Latvia';
import Lebanon from './nations/Lebanon';
import Lesotho from './nations/Lesotho';
import Liberia from './nations/Liberia';
import Libya from './nations/Libya';
import Liechtenstein from './nations/Liechtenstein';
import Lithuania from './nations/Lithuania';
import Luxembourg from './nations/Luxembourg';
import Macao from './nations/Macao';
import Madagascar from './nations/Madagascar';
import Madeira from './nations/Madeira';
import Malawi from './nations/Malawi';
import Malaysia from './nations/Malaysia';
import Maldives from './nations/Maldives';
import Mali from './nations/Mali';
import Malta from './nations/Malta';
import MarshallIsland from './nations/MarshallIsland';
import Martinique from './nations/Martinique';
import Mauritania from './nations/Mauritania';
import Mauritius from './nations/Mauritius';
import Melilla from './nations/Melilla';
import Mexico from './nations/Mexico';
import Micronesia from './nations/Micronesia';
import Moldova from './nations/Moldova';
import Monaco from './nations/Monaco';
import Mongolia from './nations/Mongolia';
import Montenegro from './nations/Montenegro';
import Montserrat from './nations/Montserrat';
import Morocco from './nations/Morocco';
import Mozambique from './nations/Mozambique';
import Myanmar from './nations/Myanmar';
import Namibia from './nations/Namibia';
import Nauru from './nations/Nauru';
import Nepal from './nations/Nepal';
import Netherlands from './nations/Netherlands';
import NewZealand from './nations/NewZealand';
import Nicaragua from './nations/Nicaragua';
import Niger from './nations/Niger';
import Nigeria from './nations/Nigeria';
import Niue from './nations/Niue';
import NorfolkIsland from './nations/NorfolkIsland';
import NorthernCyprus from './nations/NorthernCyprus';
import NorthernMarianasIslands from './nations/NorthernMarianasIslands';
import NorthKorea from './nations/NorthKorea';
import Norway from './nations/Norway';
import Oman from './nations/Oman';
import OrkneyIslands from './nations/OrkneyIslands';
import Ossetia from './nations/Ossetia';
import Pakistan from './nations/Pakistan';
import Palau from './nations/Palau';
import Palestine from './nations/Palestine';
import Panama from './nations/Panama';
import PapuaNewGuinea from './nations/PapuaNewGuinea';
import Paraguay from './nations/Paraguay';
import Peru from './nations/Peru';
import Philippines from './nations/Philippines';
import PitcairnIslands from './nations/PitcairnIslands';
import Poland from './nations/Poland';
import Portugal from './nations/Portugal';
import PuertoRico from './nations/PuertoRico';
import Qatar from './nations/Qatar';
import RapaNui from './nations/RapaNui';
import RepublicOfMacedonia from './nations/RepublicOfMacedonia';
import RepublicOfTheCongo from './nations/RepublicOfTheCongo';
import Romania from './nations/Romania';
import Russia from './nations/Russia';
import Rwanda from './nations/Rwanda';
import SabaIsland from './nations/SabaIsland';
import SahwariArabDemocraticRepublic from './nations/SahwariArabDemocraticRepublic';
import Samoa from './nations/Samoa';
import SanMarino from './nations/SanMarino';
import SaoTomeAndPrince from './nations/SaoTomeAndPrince';
import Sardinia from './nations/Sardinia';
import SaudiArabia from './nations/SaudiArabia';
import Scotland from './nations/Scotland';
import Senegal from './nations/Senegal';
import Serbia from './nations/Serbia';
import Seychelles from './nations/Seychelles';
import SierraLeone from './nations/SierraLeone';
import Singapore from './nations/Singapore';
import SintEustatius from './nations/SintEustatius';
import SintMaarten from './nations/SintMaarten';
import Slovakia from './nations/Slovakia';
import Slovenia from './nations/Slovenia';
import SolomonIslands from './nations/SolomonIslands';
import Somalia from './nations/Somalia';
import Somaliland from './nations/Somaliland';
import SouthAfrica from './nations/SouthAfrica';
import SouthKorea from './nations/SouthKorea';
import SouthSudan from './nations/SouthSudan';
import Spain from './nations/Spain';
import SriLanka from './nations/SriLanka';
import StBarts from './nations/StBarts';
import StLucia from './nations/StLucia';
import StVincentAndTheGrenadines from './nations/StVincentAndTheGrenadines';
import Sudan from './nations/Sudan';
import Surinmane from './nations/Surinmane';
import Swaziland from './nations/Swaziland';
import Sweden from './nations/Sweden';
import Switzerland from './nations/Switzerland';
import Syria from './nations/Syria';
import Taiwan from './nations/Taiwan';
import Tajikistan from './nations/Tajikistan';
import Tanzania from './nations/Tanzania';
import Thailand from './nations/Thailand';
import Tibet from './nations/Tibet';
import Togo from './nations/Togo';
import Tokelau from './nations/Tokelau';
import Tonga from './nations/Tonga';
import Transnistria from './nations/Transnistria';
import TrinidadAndTobago from './nations/TrinidadAndTobago';
import Tunisia from './nations/Tunisia';
import Turkey from './nations/Turkey';
import Turkmenistan from './nations/Turkmenistan';
import TurksAndCaicos from './nations/TurksAndCaicos';
import Tuvalu from './nations/Tuvalu';
import Uganda from './nations/Uganda';
import Ukraine from './nations/Ukraine';
import UnitedArabEmirates from './nations/UnitedArabEmirates';
import UnitedKingdom from './nations/UnitedKingdom';
import UnitedNations from './nations/UnitedNations';
import UnitedStates from './nations/UnitedStates';
import Uruguay from './nations/Uruguay';
import Uzbekistan from './nations/Uzbekistan';
import Vanuatu from './nations/Vanuatu';
import VaticanCity from './nations/VaticanCity';
import Venezuela from './nations/Venezuela';
import Vietnam from './nations/Vietnam';
import VirginIslands from './nations/VirginIslands';
import Wales from './nations/Wales';
import Yemen from './nations/Yemen';
import Zambia from './nations/Zambia';
import Zimbabwe from './nations/Zimbabwe';

// reactions
import AngryReact from './reactions/AngryReact';
import CareReact from './reactions/CareReact';
import HahaReact from './reactions/HahaReact';
import LikeReact from './reactions/LikeReact';
import LoveReact from './reactions/LoveReact';
import SadReact from './reactions/SadReact';
import UnlikeReact from './reactions/UnlikeReact';
import UnlikeReactWhiteBG from './reactions/UnlikeReactWhiteBG';
import WowReact from './reactions/WowReact';

// sports
import AmericanFootball from './sports/AmericanFootball';
import Baseball from './sports/Baseball';
import Basketball from './sports/Basketball';
import Boxing from './sports/Boxing';
import CarRace from './sports/CarRace';
import Cricket from './sports/Cricket';
import Football from './sports/Football';
import Mma from './sports/Mma';
import Tennis from './sports/Tennis';

// Socials
import ArrowDown from './ArrowDown';
import Download from './Download';
import ArrowUp from './ArrowUp';
import CopyLink from './CopyLink';
import More from './More';
import Facebook from './socials/Facebook';
import FacebookIcon from './socials/Facebook-icon';
import Instagram from './socials/Instagram';
import InstagramColored from './socials/InstagramColored';
import Telegram from './socials/Telegram';
import Twitter from './socials/Twitter';
import WhatsApp from './socials/WhatsApp';
import Youtube from './socials/Youtube';

// Media Share
import Ascending from './Ascending';
import Descending from './Descending';
import Grid from './Grid';
import Posts from './Posts';
import ShoutoutMegaphone from './ShoutoutMegaphone';

// SubscriptionPlans
import VipNav from './VipNav';

const icons = {
  down: Down,
  right: Right,
  downThin: DownThin,
  close: Close,
  menu: Menu,
  add: Add,
  check: Check,
  arrowRightRounded: ArrowRightRounded,
  arrowLeftRounded: ArrowLeftRounded,
  arrowRightLong: ArrowRightLong,
  arrowRightLonger: ArrowRightLonger,
  arrowLeftLong: ArrowLeftLong,
  upload: Upload,
  edit: Edit,
  refresh: Refresh,
  like: Like,
  unlike: Unlike,
  share: Share,
  closeOutline: CloseOutline,
  visibleOn: VisibleOn,
  visibleOff: VisibleOff,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  search: Search,
  homeFilled: HomeFilled,
  homeOutline: HomeOutline,
  browseFilled: BrowseFilled,
  browseOutline: BrowseOutline,
  shoutoutFilled: ShoutoutFilled,
  shoutoutOutline: ShoutoutOutline,
  adplayazFilled: AdPlayazFilled,
  adplayazOutline: AdPlayazOutline,
  requestsFilled: RequestsFilled,
  requestsOutline: RequestsOutline,
  downFilled: DownFilled,
  marketplaceFilled: MarketplaceFilled,
  marketplaceOutline: MarketplaceOutline,
  profileFilled: ProfileFilled,
  profileOutline: ProfileOutline,
  addCircle: AddCircle,
  addCircleOutline: AddCircleOutline,
  notificationOutline: NotificationOutline,
  notification: Notification,
  chat: Chat,
  play: Play,
  playCircle: PlayCircle,
  pause: Pause,
  settings: Settings,
  starOutline: StarOutline,
  contact: Contact,
  privacy: Privacy,
  privacyProfile: PrivacyProfile,
  privacyProfileWithProfileIcon: PrivacyProfileWithProfileIcon,
  profileVerified: ProfileVerified,
  emailNotification: EmailNotification,
  changePassword: ChangePassword,
  language: Language,
  palette: Palette,
  logout: Logout,
  doneOutline: DoneOutline,
  addComment: AddComment,
  camera: Camera,
  athletes: Athletes,
  game: Game,
  suggested: Suggested,
  emoji: Emoji,
  send: Send,
  attach: Attach,
  addChat: AddChat,
  addGroup: AddGroup,
  block: Block,
  clean: Clean,
  delete: Delete,
  hide: Hide,
  mute: Mute,
  image: Image,
  people: People,
  musicOff: MusicOff,
  filter: Filter,
  done: Done,
  starFilled: StarFilled,
  video: Video,
  videoCamera: VideoCamera,
  event: Event,
  rightChevron: RightChevron,
  roundedLike: RoundedLike,
  roundedHome: RoundedHome,
  plus: Plus,
  minus: Minus,
  calendar: Calendar,
  leftChevron: LeftChevron,
  markEmailread: MarkEmailRead,
  scheduleAvailable: ScheduleAvailable,
  scheduleCancelled: ScheduleCancelled,
  scheduleNote: ScheduleNote,
  schedulePending: SchedulePending,
  roundedQuestionMark: RoundedQuestionMark,
  videoOff: VideoOff,
  microphone: Microphone,
  closeCircled: CloseCircled,
  warning: Warning,
  repost: Repost,
  storeOutline: StoreOutline,
  storeFilled: StoreFilled,
  messagesOutline: MessagesOutline,
  messagesFilled: MessagesFilled,
  switchCamera: SwitchCamera,
  switchCamera2: SwitchCamera2,
  notificationFilled: NotificationFilled,
  squareProfile: SquareProfile,
  factCheck: FactCheck,
  receipt: Receipt,
  dashboardFilled: DashboardFilled,
  dashboardOutline: DashboardOutline,
  link: Link,
  schedule: Schedule,
  barChart: BarChart,
  forwardToInbox: ForwardToInbox,
  addPerson: AddPerson,
  playOutline: PlayOutline,
  up: Up,
  warningOutline: WarningOutline,
  sendOutline: SendOutline,
  sport: Sport,
  throphy: Throphy,
  police: Police,
  flashOn: FlashOn,
  flashOff: FlashOff,
  allInclusive: AllInclusive,
  doubleCheck: DoubleCheck,
  noPhotos: NoPhotos,
  gallery: Gallery,
  cart: Cart,
  heart: Heart,
  ruler: Ruler,
  expand: Expand,
  playCircleWebsite: PlayCircleWebsite,
  liveTV: LiveTV,
  addPhotos: AddPhotos,
  clone: Clone,
  profileBox: ProfileBox,
  checkIn: CheckIn,
  verified: Verified,
  addShoutout: AddShoutout,
  shoutoutMegaphoneOutline: ShoutoutMegaphoneOutline,
  sortVariant: SortVariant,
  trashbin: Trashbin,
  megaphone: Megaphone,

  // nations
  abkhazia: Abkhazia,
  argentina: Argentina,
  bangladesh: Bangladesh,
  bonaire: Bonaire,
  burundi: Burundi,
  chile: Chile,
  cuba: Cuba,
  ecuador: Ecuador,
  faroeIslands: FaroeIslands,
  ghana: Ghana,
  guyana: Guyana,
  haiti: Haiti,
  iraq: Iraq,
  kazakhstan: Kazakhstan,
  afghanistan: Afghanistan,
  alandIslands: AlandIslands,
  albania: Albania,
  algeria: Algeria,
  americanSamoa: AmericanSamoa,
  andorra: Andorra,
  angola: Angola,
  anguilla: Anguilla,
  antiguaAndBarbuda: AntiguaAndBarbuda,
  armenia: Armenia,
  aruba: Aruba,
  australia: Australia,
  azerbaijan: Azerbaijan,
  azoresIslands: AzoresIslands,
  bahamas: Bahamas,
  bahrain: Bahrain,
  balearicIslands: BalearicIslands,
  barbados: Barbados,
  basqueCountry: BasqueCountry,
  belarus: Belarus,
  belgium: Belgium,
  belize: Belize,
  benin: Benin,
  bermuda: Bermuda,
  bhutan: Bhutan,
  britishIndianOceanTerritory: BritishIndianOceanTerritory,
  britishVirginIslands: BritishVirginIslands,
  brunei: Brunei,
  bulgaria: Bulgaria,
  burkinaFaso: BurkinaFaso,
  cambodia: Cambodia,
  cameroon: Cameroon,
  canaryIslands: CanaryIslands,
  capeVerde: CapeVerde,
  caymanIslands: CaymanIslands,
  centralAfricanRepublic: CentralAfricanRepublic,
  ceuta: Ceuta,
  chad: Chad,
  china: China,
  cocosIslands: CocosIslands,
  colombia: Colombia,
  comoros: Comoros,
  congo: Congo,
  cookIslands: CookIslands,
  corsica: Corsica,
  costaRica: CostaRica,
  croatia: Croatia,
  curacao: Curacao,
  cyprus: Cyprus,
  czechRepublic: CzechRepublic,
  djibouti: Djibouti,
  dominica: Dominica,
  dominicanRepublic: DominicanRepublic,
  eastTimor: EastTimor,
  egypt: Egypt,
  elSalvador: ElSalvador,
  england: England,
  equatorialGuinea: EquatorialGuinea,
  eritrea: Eritrea,
  estonia: Estonia,
  ethiopia: Ethiopia,
  europeanUnion: EuropeanUnion,
  falklandIslands: FalklandIslands,
  fiji: Fiji,
  finland: Finland,
  france: France,
  frenchPolynesia: FrenchPolynesia,
  gabon: Gabon,
  galapagosIslands: GalapagosIslands,
  gambia: Gambia,
  georgia: Georgia,
  germany: Germany,
  gibraitar: Gibraitar,
  greece: Greece,
  greenland: Greenland,
  grenada: Grenada,
  guam: Guam,
  guatemala: Guatemala,
  guernsey: Guernsey,
  guinea: Guinea,
  guineaBissau: GuineaBissau,
  hawaii: Hawaii,
  honduras: Honduras,
  hungary: Hungary,
  iceland: Iceland,
  india: India,
  indonesia: Indonesia,
  iran: Iran,
  ireland: Ireland,
  isleOfMan: IsleOfMan,
  israel: Israel,
  ivoryCoast: IvoryCoast,
  jamacia: Jamacia,
  jersey: Jersey,
  jordan: Jordan,
  kenya: Kenya,
  kiribati: Kiribati,
  kosovo: Kosovo,
  kuwait: Kuwait,
  kyrgyzstan: Kyrgyzstan,
  laos: Laos,
  latvia: Latvia,
  lebanon: Lebanon,
  lesotho: Lesotho,
  liberia: Liberia,
  libya: Libya,
  liechtenstein: Liechtenstein,
  lithuania: Lithuania,
  luxembourg: Luxembourg,
  macao: Macao,
  madagascar: Madagascar,
  madeira: Madeira,
  malawi: Malawi,
  malaysia: Malaysia,
  maldives: Maldives,
  mali: Mali,
  malta: Malta,
  marshallIsland: MarshallIsland,
  martinique: Martinique,
  mauritania: Mauritania,
  mauritius: Mauritius,
  melilla: Melilla,
  mexico: Mexico,
  micronesia: Micronesia,
  moldova: Moldova,
  monaco: Monaco,
  mongolia: Mongolia,
  montenegro: Montenegro,
  montserrat: Montserrat,
  morocco: Morocco,
  mozambique: Mozambique,
  myanmar: Myanmar,
  namibia: Namibia,
  nauru: Nauru,
  nepal: Nepal,
  newZealand: NewZealand,
  nicaragua: Nicaragua,
  niger: Niger,
  nigeria: Nigeria,
  niue: Niue,
  norfolkIsland: NorfolkIsland,
  northernCyprus: NorthernCyprus,
  northernMarianasIslands: NorthernMarianasIslands,
  northKorea: NorthKorea,
  norway: Norway,
  oman: Oman,
  orkneyIslands: OrkneyIslands,
  ossetia: Ossetia,
  pakistan: Pakistan,
  palau: Palau,
  palestine: Palestine,
  panama: Panama,
  papuaNewGuinea: PapuaNewGuinea,
  paraguay: Paraguay,
  peru: Peru,
  pitcairnIslands: PitcairnIslands,
  poland: Poland,
  portugal: Portugal,
  puertoRico: PuertoRico,
  qatar: Qatar,
  rapaNui: RapaNui,
  republicOfMacedonia: RepublicOfMacedonia,
  republicOfTheCongo: RepublicOfTheCongo,
  romania: Romania,
  rwanda: Rwanda,
  sabaIsland: SabaIsland,
  sahwariArabDemocraticRepublic: SahwariArabDemocraticRepublic,
  samoa: Samoa,
  sanMarino: SanMarino,
  saoTomeAndPrince: SaoTomeAndPrince,
  sardinia: Sardinia,
  saudiArabia: SaudiArabia,
  scotland: Scotland,
  senegal: Senegal,
  serbia: Serbia,
  seychelles: Seychelles,
  sierraLeone: SierraLeone,
  singapore: Singapore,
  sintEustatius: SintEustatius,
  sintMaarten: SintMaarten,
  slovakia: Slovakia,
  slovenia: Slovenia,
  solomonIslands: SolomonIslands,
  somalia: Somalia,
  somaliland: Somaliland,
  southAfrica: SouthAfrica,
  southKorea: SouthKorea,
  southSudan: SouthSudan,
  sriLanka: SriLanka,
  stBarts: StBarts,
  stLucia: StLucia,
  stVincentAndTheGrenadines: StVincentAndTheGrenadines,
  sudan: Sudan,
  surinmane: Surinmane,
  swaziland: Swaziland,
  sweden: Sweden,
  switzerland: Switzerland,
  syria: Syria,
  taiwan: Taiwan,
  tajikistan: Tajikistan,
  tanzania: Tanzania,
  thailand: Thailand,
  tibet: Tibet,
  togo: Togo,
  tokelau: Tokelau,
  tonga: Tonga,
  transnistria: Transnistria,
  trinidadAndTobago: TrinidadAndTobago,
  tunisia: Tunisia,
  turkey: Turkey,
  turkmenistan: Turkmenistan,
  turksAndCaicos: TurksAndCaicos,
  tuvalu: Tuvalu,
  uganda: Uganda,
  unitedArabEmirates: UnitedArabEmirates,
  unitedNations: UnitedNations,
  uruguay: Uruguay,
  uzbekistan: Uzbekistan,
  vanuatu: Vanuatu,
  vaticanCity: VaticanCity,
  venezuela: Venezuela,
  vietnam: Vietnam,
  virginIslands: VirginIslands,
  wales: Wales,
  yemen: Yemen,
  zambia: Zambia,
  zimbabwe: Zimbabwe,

  unitedStates: UnitedStates,
  austria: Austria,
  canada: Canada,
  denmark: Denmark,
  hongKong: HongKong,
  italy: Italy,
  japan: Japan,
  netherlands: Netherlands,
  philippines: Philippines,
  russia: Russia,
  spain: Spain,
  ukraine: Ukraine,
  unitedKingdom: UnitedKingdom,

  // reactions
  angryReact: AngryReact,
  careReact: CareReact,
  hahaReact: HahaReact,
  likeReact: LikeReact,
  unlikeReact: UnlikeReact,
  unlikeReactWhiteBG: UnlikeReactWhiteBG,
  loveReact: LoveReact,
  sadReact: SadReact,
  wowReact: WowReact,

  // sports
  americanFootball: AmericanFootball,
  baseball: Baseball,
  basketball: Basketball,
  boxing: Boxing,
  cricket: Cricket,
  football: Football,
  mma: Mma,
  carRace: CarRace,
  tennis: Tennis,

  // Socials
  facebook: Facebook,
  instagram: Instagram,
  twitter: Twitter,
  whatsApp: WhatsApp,
  telegram: Telegram,

  // mediaShare
  posts: Posts,
  grid: Grid,
  shoutoutMegaphone: ShoutoutMegaphone,
  ascending: Ascending,
  descending: Descending,
  insta: InstagramColored,
  youtube: Youtube,
  facebookIcon: FacebookIcon,

  more: More,
  copyLink: CopyLink,
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  stripe: Stripe,
  komoju: Komoju,
  creditCard: CreditCard,
  applePay: ApplePay,
  googlePay: GooglePay,
  lock: Lock,
  vip: VipNav,
  subscribedCheck: SubscribedCheck,
  paywallMessageCircle: PaywallMessageCircle,
  paywallWand: PaywallWand,
  paywallShield: PaywallShield,
  paywallCrown: PaywallCrown,
  paywallCheck: PaywallCheck,
  paywallApple: PaywallApple,
  paywallCircleX: PaywallCircleX,
  paywallCreditCard: PaywallCreditCard,
  download: Download
};

export default icons;
